import { useEffect, useState } from 'react';

//components
import { Card } from 'primereact/card';

//api
import { KBService } from '../../../service/kb-service';

        

const KBCard = ()=>{
    const [kb,setKb]= useState(0)

    useEffect(()=>{
        const fetchKB = ()=>{
            KBService.getAllKBFiles(
                (data)=>{
                    setKb(data.count)
                },
                (error) => {
                    console.error("Errore durante il recupero dei file kb: ", error);
                    
                }
            )
        }
        fetchKB()
    },[])

    return (
        <div>
            <Card title="Knowledge Base" className='dashboard__KBWrapper'>
                <div className='dashboard__CardContent'>
                    <div>
                     {kb}
                    </div>
                    <div>
                       <i className='pi pi-building-columns'></i> 
                    </div>
                </div>
                <div className='dashboard__Link'>
                    <a href='/dashboard/kb'>Vai alla Knowledge Base <i className='pi pi-arrow-right' ></i></a>
                </div>
            </Card>
        </div>
    )
}

export default KBCard